<template>
    <div class="gas-wrap">
        <div class="total-wrap">
            <div class="total-gas item">
                <div class="mark">
                    <i class="iconfont ">&#xe617;</i>
                </div>
                <div class="icon-wrap icon-g">
                    <i class="iconfont ">&#xe617;</i>
                </div>
                <div class="label">
                    <div>{{totalGas}}</div>
                    <div>总用气量(T)</div>
                </div>
            </div>
            <div class="total-heat item">
                <div class="mark">
                    <i class="iconfont ">&#xe617;</i>
                </div>
                <div class="icon-wrap icon-h">
                    <i class="iconfont">&#xe6c0;</i>
                </div>
                <div class="label">
                    <div>{{reportdata.total.SumHeat.quantity}}</div>
                    <div>总用热量(GJ)</div>
                </div>
            </div>
            <div class="total-cost item">
                <div class="mark">
                    <i class="iconfont ">&#xe617;</i>
                </div>
                <div class="icon-wrap icon-c">
                    <i class="iconfont">&#xe634;</i>
                </div>
                <div class="label">
                    <div>{{totalCost}}</div>
                    <div>费用(￥)</div>
                </div>
            </div>
        </div>

        <div class="chart-wrap">
             <div class="mark">
                <i class="iconfont ">&#xe617;</i>
            </div>
            <div class="chart">

            </div>
        </div>
    </div>
</template>
<script>
// 蒸汽图表
const chartOption = {
  tooltip: {
    trigger: "axis",
    formatter: function (datas) {
      var res = datas[0].name + "<br/>";
      res +=
        '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#59CC5D"></span>';
      res += datas[0].seriesName + "：" + datas[0].value + "T" + "<br/>";
      res +=
        '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#FEC54A"></span>';
      res +=
        datas[1].seriesName + "：" + Math.abs(datas[1].value) + "TG" + "<br/>";
      res +=
        '<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#578AFF"></span>';
      res += datas[2].seriesName + "：" + datas[2].value + "元" + "<br/>";

      return res;
    },
    axisPointer: {
      type: "none",
      crossStyle: {
        color: "#999",
      },
      label: {},
    },
  },
  toolbox: {
    feature: {
      saveAsImage: { show: true },
    },
  },
  legend: {
    // data: ["用汽量", "用热量", "￥"],
    icon: "circle",
    textStyle: {
      //图例文字的样式
      color: "#5B5B5B",
      fontSize: "12",
    },
    itemGap: 100, // 设置legend的间距
    // itemWidth: 130, // 设置宽度
    itemHeight: 14, // 设置高度
  },
  xAxis: [
    {
      type: "category",
      data: [],
      axisPointer: {
        type: "shadow",
      },
    },
  ],
  yAxis: [
    {
      type: "value",
      name: "(T)",
      splitLine: {
        //网格线
        show: true,
        lineStyle: {
          type: "dashed",
          color: "#E5E5E5",
        },
      },
      interval: 10,
      axisLabel: {
        formatter: function (value) {
          if (value < 0) {
            return -value;
          } else {
            return value;
          }
        },
      },
    },
    {
      type: "value",
      name: "（￥）",
      splitLine: {
        //网格线
        show: true,
        lineStyle: {
          type: "dashed",
          color: "#E5E5E5",
        },
      },
      interval: 2000,
      axisLabel: {
        formatter: function (value) {
          if (value < 0) {
            return -value;
          } else {
            return value;
          }
        },
      },
    },
  ],
  series: [],
};

// 引入echarts图表
import echarts from 'echarts/lib/echarts';

export default {
    name:"gas",
    props:["reportdata"],
    computed:{
        // 总用气量
        totalGas:function(){
            let total=0.0;
            let SumFlux=this.reportdata.total.SumFlux;
            let quantity=SumFlux.quantity;
            for(let itN in quantity){
                let temp=quantity[itN];
                total+=temp;
            }
            return total;
        },
        // 总费用
        totalCost:function(){
            let total=0.0;
            let SumFlux=this.reportdata.total.SumFlux;
            let fee=SumFlux.fee;
            for(let itN in fee){
                let temp=fee[itN];
                total+=temp;
            }
            return total;
        }
    },
    mounted(){
       this.init_chart();
    },
    methods:{
        // 初始化图表
        init_chart(){
            let reportdata=this.reportdata;
            // 设置时间(X轴)
            chartOption.xAxis[0].data=reportdata.times;

            // 清空
            chartOption.series=[];
            // 遍历对象，生成用气量
            let branch=reportdata.branch;
            let quantity=branch.SumFlux.quantity
            for(let itN in quantity){
                // 新建series
                let seriesItem= {
                    name: reportdata.price['平']+"￥/T \n 用汽量",
                    type: "bar",
                    stack: "one",
                    itemStyle: {
                        normal: {
                        color: "#59CC5D",
                        barBorderRadius: [8, 8, 0, 0],
                        },
                    },
                    barWidth: 15, //柱子宽度
                    data: quantity[itN],
                }
                chartOption.series.push(seriesItem);
            }

            // 生成用热量
            quantity=branch.SumHeat.quantity;
            quantity=quantity.map(i=>-i);
            let seriesItem= {
                name: "用热量",
                type: "bar",
                stack: "one",
                itemStyle: {
                    normal: {
                    color: "#FEC54A",
                    barBorderRadius: [0, 0, 8, 8],
                    },
                },
                barWidth: 15, //柱子宽度
                data: quantity,
            }
            chartOption.series.push(seriesItem);

            // 生成费用表
            let fee=branch.SumFlux.fee;
            seriesItem={
                name: "￥",
                type: "line",
                stack: "two",
                itemStyle: {
                    normal: {
                    color: "#578AFF",
                    lineStyle: {
                        width: 3,
                    },
                    },
                },
                yAxisIndex: 1,
                data: fee,
            };
            chartOption.series.push(seriesItem);

            // Legend
            let legend=[reportdata.price['平']+"￥/T \n 用汽量","用热量","￥"];
            chartOption.legend.data=legend;

            // 初始化图表
            let ele=this.$el.querySelector(".chart-wrap .chart");
            echarts.init(ele).setOption(chartOption, true);
        }
    }
}
</script>

<style lang="scss">
.gas-wrap{
            
    .mark{
        position: absolute;
        left: 10px;
        top:10px;
        color: #BDDAFF;
    }
    .total-wrap{
        display: flex;

        .item{
            flex:1;
            justify-content: center;
            position: relative;
            display: flex;
            padding:20px;
            background: #fff;
            margin:5px;
            border-radius: 10px;

            .icon-wrap{
                width:50px;
                height: 50px;
                border-radius: 40px;
                margin-right: 10px;
                line-height: 50px;
                text-align: center;
                color: #fff;

                i{
                    font-size: 30px;
                }
                
                &.icon-g{
                    background: #4E84FF;
                }

                &.icon-h{
                    background: #FE5D66;
                }

                &.icon-c{
                    background: #58CC5C;
                }
            }

            .label{
                & div:first-child{
                    margin-top:6px;
                }
            }

        }
    }
    /** 图表 */
    .chart-wrap{
        background: #fff;
        border-radius: 10px;
        margin:10px 5px;
        position: relative;

        .chart{
            min-height: 400px;
        }
    }

}
</style>